import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import RichText from '../../../components/RichEditor/RichText'
import { compare } from './diff_compare_object'
import TableComponent from '../../../components/Common/TableComponent'
import uuid from 'uuid'

const DiffTable = props => {
  const { type, dataBefore, dataAfter } = props

  const [diffList, setDiffList] = useState([])

  useEffect(() => {
    try {
      // Parse JSON strings, handle null/undefined
      const parsedBefore = dataBefore ? JSON.parse(dataBefore) : null
      const parsedAfter = dataAfter ? JSON.parse(dataAfter) : null

      // Get comparison result and ensure it's an array
      const result = compare(type, parsedBefore, parsedAfter)
      setDiffList(Array.isArray(result) ? result : [])
    } catch (error) {
      console.error('Error parsing diff data:', error)
      setDiffList([])
    }
  }, [type, dataBefore, dataAfter])

  // Don't render table if there's no data
  if (diffList.length === 0) {
    return (
      <p style={{ fontStyle: 'italic', color: '#888', marginLeft: 8 }}>
        Không có thay đổi
      </p>
    )
  }

  const columns = [
    {
      title: 'Trường dữ liệu',
      width: 150,
      render: record => <RichText htmlText={record.field}></RichText>,
    },
    {
      title: 'Trước thay đổi',
      width: 300,
      render: record => (
        <RichText htmlText={record.fieldValueBefore}></RichText>
      ),
    },
    {
      title: 'Sau thay đổi',
      width: 300,
      render: record => <RichText htmlText={record.fieldValueAfter}></RichText>,
    },
  ]

  return (
    <div>
      <TableComponent
        rowKey={() => uuid()}
        dataSource={diffList}
        columns={columns}
        pagination={false}
      />
    </div>
  )
}

DiffTable.propTypes = {
  dataBefore: PropTypes.string,
  dataAfter: PropTypes.string,
  type: PropTypes.string,
}

export default DiffTable
